/* eslint-disable array-callback-return */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState, useEffect } from "react";
import "../css/campaignListcss.css";
import "../css/lineclamp2css.css";
import { Modal } from "./ui";
import Swal from "sweetalert2";
import { useLocation } from "react-router-dom";
import ScrollToTopButton from "./ScrollToTopButton";
import { useTranslation } from "react-i18next";
import Cookies from "js-cookie";
import { CmsService } from "../services/cmsService";
import formErrorPopupInstance from "../utils/formValidation.js";
import { Icon } from "./ui";

function SubCategories() {
  const [savedLanguage, setSaveLanguage] = useState();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setSaveLanguage(i18n.language);
  }, [i18n.language]);

  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [isMobileScreen, setIsMobileScreen] = useState(
    window.innerWidth <= 1250 ? true : false
  );
  const location = useLocation();
  const mainCategoryId =
    location.state?.mainCategoryId === undefined
      ? ""
      : location.state.mainCategoryId;
  const mainCategoryEnglish =
    location.state?.mainCategoryEnglish === undefined
      ? ""
      : location.state.mainCategoryEnglish;
  const mainCategoryHk =
    location.state?.mainCategoryHk === undefined
      ? ""
      : location.state.mainCategoryHk;
  const mainCategoryCn =
    location.state?.mainCategoryCn === undefined
      ? ""
      : location.state.mainCategoryCn;
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [editIsOpen, setEditIsOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryEnglish, setCategoryEnglish] = useState("");
  const [categoryZHTW, setCategoryZHTW] = useState("");
  const [categoryZHCN, setCategoryZHCN] = useState("");
  //   const [categoryId, setCategoryId] = useState('');
  const [upperCategoryId, setUpperCategoryId] = useState("");
  const [categoryId, setCategoryId] = useState("");

  useEffect(() => {
    const savedLanguage = Cookies.get("language");
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
    }
  }, [i18n]);

  useEffect(() => {
    function handleResize() {
      setIsMobileScreen(window.innerWidth <= 1250);
      // setXsIsMobileScreen(window.screen.width<= 385);
    }

    handleResize();
    window.addEventListener("resize", handleResize);

    // Add this block to update isMobileScreen when the screen size is larger than 1207 pixels
    return () => {
      window.removeEventListener("resize", handleResize);
      setIsMobileScreen(false);
      // setXsIsMobileScreen(false);
    };
  }, []);

  useEffect(() => {
    var cmsService = new CmsService();
    cmsService
      .retrieveCategoryList()
      .then((value) => {
        return value.data;
      })
      .then((data) => {
        setCategories(data.firstLevelCategoryList);
      })
      .catch((error) => console.error(error));
  }, []);

  const openModal = () => {
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const openEdit = (data) => {
    setCategoryEnglish(data.categoryNameEng);
    setCategoryZHCN(data.categoryNameCn);
    setCategoryZHTW(data.categoryNameHk);
    setUpperCategoryId(data.upperCategoryId);
    setCategoryId(data.categoryId);
    setEditIsOpen(true);
  };

  const closeEdit = () => {
    setEditIsOpen(false);
    setCategoryEnglish("");
    setCategoryZHCN("");
    setCategoryZHTW("");
    setUpperCategoryId("");
    setCategoryId("");
  };

  const showEditMobile = (data) => {
    setCategoryEnglish(data.categoryNameEng);
    setCategoryZHCN(data.categoryNameCn);
    setCategoryZHTW(data.categoryNameHk);
    setUpperCategoryId(data.upperCategoryId);
    setCategoryId(data.categoryId);
    setShowEditModal(true);
  };

  const closeEditMobile = () => {
    setShowEditModal(false);
    setCategoryEnglish("");
    setCategoryZHCN("");
    setCategoryZHTW("");
    setUpperCategoryId("");
    setCategoryId("");
  };

  const showCreateMobile = () => {
    setShowModal(true);
  };

  const closeCreateMobile = () => {
    setShowModal(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (categoryEnglish === "") {
      formErrorPopupInstance.addError(t("cms.mainCategories.mainCateEng"));
    }

    if (categoryZHCN === "") {
      formErrorPopupInstance.addError(t("cms.mainCategories.mainCateCn"));
    }

    if (categoryZHTW === "") {
      formErrorPopupInstance.addError(t("cms.mainCategories.mainCateHk"));
    }

    formErrorPopupInstance.showErrors();
    e.preventDefault();
    if (formErrorPopupInstance.errors.length === 0) {
      var cmsService = new CmsService();
      cmsService
        .retrieveCategory(
          0,
          mainCategoryId,
          "create",
          categoryEnglish.trim(),
          categoryZHCN.trim(),
          categoryZHTW.trim()
        )
        .then((value) => {
          console.log(value.status);
          if (value.status && value.status === 200) {
            closeModal();
            Swal.fire({
              icon: "success",
              title: t("cms.subCategoryCreated"),
              showConfirmButton: false,
              timer: 1700,
            }).then(function () {
              window.location = "/SubCategories";
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: t("cms.duplicated"),
          });
        });
    }
    formErrorPopupInstance.clearErrors();
  };

  const handleEdit = async (e) => {
    e.preventDefault();

    if (categoryEnglish === "") {
      formErrorPopupInstance.addError(t("cms.mainCategories.mainCateEng"));
    }

    if (categoryZHCN === "") {
      formErrorPopupInstance.addError(t("cms.mainCategories.mainCateCn"));
    }

    if (categoryZHTW === "") {
      formErrorPopupInstance.addError(t("cms.mainCategories.mainCateHk"));
    }

    formErrorPopupInstance.showErrors();
    e.preventDefault();
    if (formErrorPopupInstance.errors.length === 0) {
      var cmsService = new CmsService();
      cmsService
        .retrieveCategory(
          categoryId,
          upperCategoryId,
          "edit",
          categoryEnglish.trim(),
          categoryZHCN.trim(),
          categoryZHTW.trim()
        )
        .then((value) => {
          if (value.status === 200) {
            closeEdit();
            Swal.fire({
              icon: "success",
              title: t("cms.subCategoryUpdated"),
              showConfirmButton: false,
              timer: 1700,
            }).then(function () {
              window.location = "/SubCategories";
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: t("cms.duplicated"),
          });
        });
    }
    formErrorPopupInstance.clearErrors();
  };

  const handleDelete = async (categoryId) => {
    // Show a confirmation dialog before deleting the URL
    const result = await Swal.fire({
      icon: "warning",
      title: t("common.deleteConfirmText"),
      showCancelButton: true,
      confirmButtonColor: "#dc3545", // set confirm button color to red
      confirmButtonText: t("common.delete"),
      cancelButtonText: t("common.cancel"),
    });

    // Check if the user clicked the delete button
    if (result.isConfirmed) {
      var cmsService = new CmsService();
      cmsService.retrieveCategory(categoryId, 0, "delete").then((value) => {
        if (value.status === 200) {
          // Reload the page to show the updated list of links
          window.location.reload();
        } else {
          // Handle error
          console.error("Error deleting item");
        }
      });
    }
  };

  return (
    <>
      {isMobileScreen ? (
        <>
          <div className="w-full">
            <div className="flex">
              <div className="w-3/4">
                <a
                  className="no-underline text-ft-light hover:text-ft"
                  href="/categories">
                  <h1 className="text-header font-bold w-3/4 mt-2 text-ft-light">
                    {savedLanguage === "en"
                      ? mainCategoryEnglish
                      : savedLanguage === "cn"
                      ? mainCategoryCn
                      : mainCategoryHk}{" "}
                    - {t("cms.subCategories")}
                  </h1>
                </a>
              </div>
              <a
                onClick={() => showCreateMobile()}
                className="no-underline w-1/4 text-tableHeader bg-ft-light text-center text-white py-2 px-3 rounded hover:bg-ft active:bg-white active:text-ft active:ring-1 active:ring-ft">
                {t("common.create")}
              </a>
            </div>

            {showModal ? (
              <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                  <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-5">
                      <form onSubmit={handleSubmit}>
                        <div className="">
                          <div className="">
                            <div className="mt-3">
                              <label htmlFor="categoryEnglish">
                                {t("cms.subCategories.subCateEng")}
                                <span className="text-red-600">*</span>:
                              </label>
                              <input
                                type="text"
                                id="categoryEnglish"
                                value={categoryEnglish}
                                className="w-full ring-ft-light focus:border-0 border-gray-500"
                                onChange={(e) =>
                                  setCategoryEnglish(e.target.value)
                                }
                              />
                            </div>
                            <div className="mt-3">
                              <label htmlFor="categoryZHTW">
                                {t("cms.subCategories.subCateHk")}
                                <span className="text-red-600">*</span>:
                              </label>
                              <input
                                type="text"
                                id="categoryZHTW"
                                value={categoryZHTW}
                                className="w-full ring-ft-light focus:border-0 border-gray-500"
                                onChange={(e) =>
                                  setCategoryZHTW(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="mt-3">
                            <label htmlFor="categoryZHCN">
                              {t("cms.subCategories.subCateCn")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="categoryZHCN"
                              value={categoryZHCN}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setCategoryZHCN(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="w-auto max-w-96 flex mt-4">
                          <button
                            type="submit"
                            className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                            {t("common.create")}
                          </button>
                          <button
                            type="button"
                            className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                            onClick={() => closeCreateMobile()}>
                            {t("common.cancel")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
              </>
            ) : null}

            {showEditModal ? (
              <>
                <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                  <div className="relative w-5/6 my-6 mx-auto max-w-3xl">
                    {/*content*/}
                    <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none p-5">
                      <form onSubmit={handleEdit}>
                        <div className="">
                          <div className="">
                            <div className="mt-3">
                              <label htmlFor="categoryEnglish">
                                {t("cms.subCategories.subCateEng")}
                                <span className="text-red-600">*</span>:
                              </label>
                              <input
                                type="text"
                                id="categoryEnglish"
                                value={categoryEnglish}
                                className="w-full ring-ft-light focus:border-0 border-gray-500"
                                onChange={(e) =>
                                  setCategoryEnglish(e.target.value)
                                }
                              />
                            </div>
                            <div className="mt-3">
                              <label htmlFor="categoryZHTW">
                                {t("cms.subCategories.subCateHk")}
                                <span className="text-red-600">*</span>:
                              </label>
                              <input
                                type="text"
                                id="categoryZHTW"
                                value={categoryZHTW}
                                className="w-full ring-ft-light focus:border-0 border-gray-500"
                                onChange={(e) =>
                                  setCategoryZHTW(e.target.value)
                                }
                              />
                            </div>
                          </div>
                          <div className="mt-3">
                            <label htmlFor="categoryZHCN">
                              {t("cms.subCategories.subCateCn")}
                              <span className="text-red-600">*</span>:
                            </label>
                            <input
                              type="text"
                              id="categoryZHCN"
                              value={categoryZHCN}
                              className="w-full ring-ft-light focus:border-0 border-gray-500"
                              onChange={(e) => setCategoryZHCN(e.target.value)}
                            />
                          </div>
                        </div>
                        <div className="w-auto max-w-96 flex mt-4">
                          <button
                            type="submit"
                            className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                            {t("common.save")}
                          </button>
                          <button
                            type="button"
                            className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                            onClick={() => closeEditMobile()}>
                            {t("common.cancel")}
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
              </>
            ) : null}
            <div className="flex mt-4">
              <table className=" flex w-full bg-white">
                <thead className="sm:w-1/5 w-2/5 text-white text-mobileLandingContent font-bold">
                  {categories
                    .filter((cat) => cat.categoryId === mainCategoryId)
                    .map((cat) => {
                      if (cat.secondLevelCategoryList) {
                        return cat.secondLevelCategoryList.map((subCat) => (
                          <tr
                            className="pl-1 bg-ft-light flex flex-col mb-2 border border-slate-300"
                            key={subCat.categoryId}>
                            <th className="h-12 ">
                              {t("cms.subCategories.subCateEng")}
                            </th>
                            <th className="h-12">
                              {t("cms.subCategories.subCateHk")}
                            </th>

                            <th className="h-12">
                              {t("cms.subCategories.subCateCn")}
                            </th>
                            <th className="h-8">{t("common.edit")}</th>
                            <th className="h-8">{t("common.delete")}</th>
                          </tr>
                        ));
                      }
                    })}
                </thead>
                <tbody className="sm:w-4/5 w-3/5 text-mobileLandingContent line-clamp-2">
                  {categories
                    .filter((cat) => cat.categoryId === mainCategoryId)
                    .map((cat) => {
                      if (cat.secondLevelCategoryList) {
                        return cat.secondLevelCategoryList.map((subCat) => (
                          <tr
                            className="flex flex-col border border-slate-300 mb-2"
                            key={cat.categoryId}>
                            <td className="pl-3 pr-3 h-12 line-clamp-2">
                              {subCat.categoryNameEng}
                            </td>
                            <td className="pl-3 pr-3 h-12 line-clamp-2">
                              {subCat.categoryNameHk}
                            </td>
                            <td className="pl-3 pr-3 h-12 line-clamp-2">
                              {subCat.categoryNameCn}
                            </td>

                            <td className="pl-3 pr-3 h-8">
                              <a onClick={() => showEditMobile(subCat)}>
                                <Icon src="edit" color="primary" />
                              </a>
                            </td>

                            <td className="pl-3 pr-3 h-8">
                              <a
                                onClick={() => handleDelete(subCat.categoryId)}>
                                <Icon src="delete" color="primary" />
                              </a>
                            </td>
                          </tr>
                        ));
                      }
                    })}
                </tbody>
              </table>
            </div>
            {categories
              .filter((cat) => cat.categoryId === mainCategoryId)
              .map((cat) => {
                if (!cat.secondLevelCategoryList) {
                  return (
                    <>
                      {" "}
                      <div className="text-center">
                        {t("cms.subCategories.noSubCate")}
                      </div>
                    </>
                  );
                }
              })}
            <ScrollToTopButton />
          </div>
        </>
      ) : (
        <div className="w-deflaut px-2">
          <div className="flex justify-content-between align-items-center my-3">
            <div className="">
              <a
                className="no-underline text-ft-light hover:text-ft"
                href="/categories">
                <p className="text-header text-ft-light font-bold">
                  {savedLanguage === "en"
                    ? mainCategoryEnglish
                    : savedLanguage === "cn"
                    ? mainCategoryCn
                    : mainCategoryHk}{" "}
                  - {t("cms.subCategories")}
                </p>
              </a>
            </div>
            <div onClick={openModal}>
              <a
                className={
                  "no-underline hover:bg-ft text-tableHeader text-white bg-ft-light rounded px-3 py-2 cursor-pointer"
                }>
                {t("common.create")}
              </a>
            </div>

            <Modal
              open={modalIsOpen}
              onClose={closeModal}
              component="form"
              onSubmit={handleSubmit}>
              <div className="w-categories">
                <div className="">
                  <div className="mt-3">
                    <label htmlFor="categoryEnglish">
                      {t("cms.subCategories.subCateEng")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="text"
                      id="categoryEnglish"
                      value={categoryEnglish}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={(e) => setCategoryEnglish(e.target.value)}
                    />
                  </div>
                  <div className="mt-3">
                    <label htmlFor="categoryZHTW">
                      {t("cms.subCategories.subCateHk")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="text"
                      id="categoryZHTW"
                      value={categoryZHTW}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={(e) => setCategoryZHTW(e.target.value)}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <label htmlFor="categoryZHCN">
                    {t("cms.subCategories.subCateCn")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="categoryZHCN"
                    value={categoryZHCN}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setCategoryZHCN(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-auto max-w-96 flex mt-4">
                <button
                  type="submit"
                  className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                  {t("common.create")}
                </button>
                <button
                  type="button"
                  className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                  onClick={closeModal}>
                  {t("common.cancel")}
                </button>
              </div>
            </Modal>
            <Modal
              open={editIsOpen}
              onClose={closeEdit}
              component="form"
              onSubmit={handleEdit}>
              <div className="w-categories ">
                <div className="">
                  <div className="mt-3">
                    <label htmlFor="categoryEnglish">
                      {t("cms.subCategories.subCateEng")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="text"
                      id="categoryEnglish"
                      value={categoryEnglish}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={(e) => setCategoryEnglish(e.target.value)}
                    />
                  </div>
                  <div className="mt-3">
                    <label htmlFor="categoryZHTW">
                      {t("cms.subCategories.subCateHk")}
                      <span className="text-red-600">*</span>:
                    </label>
                    <input
                      type="text"
                      id="categoryZHTW"
                      value={categoryZHTW}
                      className="w-full ring-ft-light focus:border-0 border-gray-500"
                      onChange={(e) => setCategoryZHTW(e.target.value)}
                    />
                  </div>
                </div>
                <div className="mt-3">
                  <label htmlFor="categoryZHCN">
                    {t("cms.subCategories.subCateCn")}
                    <span className="text-red-600">*</span>:
                  </label>
                  <input
                    type="text"
                    id="categoryZHCN"
                    value={categoryZHCN}
                    className="w-full ring-ft-light focus:border-0 border-gray-500"
                    onChange={(e) => setCategoryZHCN(e.target.value)}
                  />
                </div>
              </div>
              <div className="w-auto max-w-96 flex mt-4">
                <button
                  type="submit"
                  className="w-1/2 mr-5 px-3 py-2 ring-ft-light bg-ft-light text-white rounded ring-1 active:bg-ft active:ring-ft">
                  {t("common.save")}
                </button>
                <button
                  type="button"
                  className="w-1/2 rounded px-3 py-2 ring-1 ring-ft-light"
                  onClick={closeEdit}>
                  {t("common.cancel")}
                </button>
              </div>
            </Modal>
          </div>
          <div className="p-2 flex align-middle justify-center">
            <div className="">
              <table className="w-full block">
                <thead className="text-tableHeader">
                  <tr className="border border-slate-300 ">
                    <th className="  pl-5 h-8">
                      <div className="inline-block h-6 w-categories">
                        {t("cms.subCategories.subCateEng")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block h-6 w-categories">
                        {t("cms.subCategories.subCateHk")}
                      </div>
                    </th>
                    <th className="  h-8 ">
                      <div className="inline-block h-6 w-categories">
                        {t("cms.subCategories.subCateCn")}
                      </div>
                    </th>

                    <th className=" h-8">
                      <div className="inline-block h-6 w-linkEdit">
                        {t("common.edit")}
                      </div>
                    </th>
                    <th className=" h-8">
                      <div className="inline-block w-linkEdit mr-2">
                        {t("common.delete")}
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody className="text-left text-content">
                  {categories
                    .filter((cat) => cat.categoryId === mainCategoryId)
                    .map((cat) => {
                      if (cat.secondLevelCategoryList) {
                        return cat.secondLevelCategoryList.map((subCat) => (
                          <tr
                            className="border border-slate-300 h-16"
                            key={subCat.categoryId}>
                            <td className="">
                              <div className="w-categoriesName truncate pl-5 items-center">
                                {subCat.categoryNameEng}
                              </div>
                            </td>
                            <td className="">
                              <div className="w-categoriesName truncate items-center align-middle">
                                {subCat.categoryNameHk}
                              </div>
                            </td>
                            <td className="">
                              <div className="w-categoriesName truncate items-center align-middle">
                                {subCat.categoryNameCn}
                              </div>
                            </td>

                            <td className="cursor-pointer">
                              <a onClick={() => openEdit(subCat)}>
                                <Icon src="edit" color="primary" />
                              </a>
                            </td>
                            <td className="relative cursor-pointer">
                              <a
                                onClick={() => handleDelete(subCat.categoryId)}>
                                <Icon src="delete" color="primary" />
                              </a>
                            </td>
                          </tr>
                        ));
                      } else {
                        return (
                          <tr className="border border-slate-300 h-16">
                            <td colSpan="4" className="text-center">
                              {t("cms.subCategories.noSubCate")}
                            </td>
                          </tr>
                        );
                      }
                    })}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default SubCategories;
